
import ServicePage from "views/Service/LandingPage.jsx";
import NewsPage from "views/News/LandingPage.jsx";
import HomePage from "views/HomePage/LandingPage.jsx";
import AboutPage from "views/AboutPage/LandingPage.jsx";
import CareerPage from "views/CareerPage/LandingPage.jsx";
import ContactPage from "views/ContactPage/LandingPage.jsx";
import News24112018 from "views/News/Article.1.jsx"
import News28112018 from "views/News/Article.2.jsx"
import News14122018 from "views/News/Article.3.jsx"
import News19122018 from "views/News/Article.4.jsx"
import News07012019 from "views/News/Article.5.jsx"
import News08012019 from "views/News/Article.6.jsx"
import News19012019 from "views/News/Article.7.jsx"
import News12022019 from "views/News/Article.8.jsx"
import News120220192 from "views/News/Article.9.jsx"
import cariso37001 from "views/CareerPage/Article.1.jsx"
import cariso27001 from "views/CareerPage/Article.2.jsx"
import carmarketing from "views/CareerPage/Article.3.jsx"


var indexRoutes = [
  { path: "/career/marketing", name: "Marketing", component: carmarketing },
  { path: "/career/iso37001consultant", name: "ISO37001", component: cariso37001 },
  { path: "/career/iso27001consultant", name: "ISO27001", component: cariso27001 },
  { path: "/newsresources/28112018/ISO-27001-sistem-manajemen-keamanan-informasi", name: "News28112018", component: News28112018 },
  { path: "/newsresources/24112018/ISO-45001:2018-pengganti-OHSAS-18001:2007", name: "News24112018", component: News24112018 },
  { path: "/newsresources/24112018/resiko-dan-peluang-pada-ISO-9001:2015", name: "News14122018", component: News14122018 },
  { path: "/newsresources/24112018/in-house-training:-audit-internal-dan-kaji-ulang-manajemen-ISO-9001:2015", name: "News19122018", component: News19122018 },
  { path: "/newsresources/07012019/SMK-PGRI-1-&-SMK-PGRI-3-:-Awareness-Training-ISO-9001:2015", name: "News07012019", component: News07012019 },
  { path: "/newsresources/24112018/PDAM-TIRTA-MUSI-:-Pelatihan-Sistem-Manajemen-Mutu-ISO-9001:2015", name: "News08012019", component: News08012019 },
  { path: "/newsresources/19012019/Pentingnya-Manajemen-Keamanan-Pangan-FSSC-22000", name: "News19012019", component: News19012019 },
  { path: "/newsresources/12022019/Sistem-Manajemen-Keamanan-Informasi,-Kunci-Utama-Pertumbuhan-Bisnis-Masa-Kini", name: "News12022019", component: News12022019 },
  { path: "/newsresources/12022019/Awareness-Training-System-ISO-45001", name: "News120220192", component: News120220192 },
  { path: "/getintouch", name: "GetInTouch", component: ContactPage },
  { path: "/career", name: "Career", component: CareerPage },
  { path: "/newsresources", name: "NewsResources", component: NewsPage },
  { path: "/about", name: "About", component: AboutPage },
  { path: "/service", name: "Service", component: ServicePage },
  { path: "/home", name: "Home", component: HomePage },
  { path: "/", name: "Home", component: HomePage }
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx